export default "__VITE_ASSET__GowLVmV5__"